import { useHistory } from 'react-router';
import { useWindow } from '@uds/hooks';
import { isInternalUrl } from 'domain/url';
import { useOrderProcessUrl } from 'domain/selectors/common';

const usePostActionNavigate = (postAction?: { type: string; url?: string }) => {
  const type = postAction?.type;
  const url = postAction?.url;
  const history = useHistory();
  const isInternal = isInternalUrl(url);
  const orderUrl = useOrderProcessUrl();
  const window = useWindow();
  const navigateUrl = type === 'CHECKOUT' ? orderUrl : url;

  return () => {
    if (navigateUrl == null) {
      return;
    }
    if (isInternal) {
      history.push(navigateUrl);
    } else {
      window.location.href = navigateUrl;
    }
  };
};

export default usePostActionNavigate;
